export default {
    "login":{
        "login-title":"欢迎登录",
        "login-btn-content":"登录",
        "username-content":"用户名",
        "password-content":"密码",
        "user-placeholder":"请输入用户名",
        "password-placeholder":"请输入密码"
    }
}